<template>
	<div class="drawer">
		<el-drawer
		v-if="detail.id"
		size="900px"
		title="医疗服务详情"
		:visible.sync="drawerStatus"
		:modal-append-to-body="false"
		:close-on-click-modal="false"
		@close='handleClose'
		>
			<div style="padding-bottom:40px;">
				<el-row class="row">
					<el-col :span="12">
						<span class="label">顾客：</span>
						<span class="value">{{detail.memberName}}</span>
					</el-col>
					<el-col :span="12">
						<span class="label">宠物：</span>
						<span class="value">{{detail.petName}}</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12" style="display: flex;">
						<span class="label">项目：</span>
						<span class="value">{{detail.serviceTypeId==1?'疫苗':'驱虫'}}</span>
					</el-col>
					<el-col :span="12">
						<span class="label">支付方式：</span>
						<span class="value">
							全额支付
						</span>
					</el-col>
					
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">套餐：</span>
						<span class="value">{{detail.medicalServiceName}}</span>
					</el-col>
					<el-col :span="12">
						<span class="label">完成时间：</span>
						<span class="value">{{$public.FTime(detail.handlerTime)}}</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">创建人：</span>
						<span class="value">{{detail.createUserName}}</span>
					</el-col>
					<el-col :span="12">
						<span class="label">创建时间：</span>
						<span class="value">{{$public.FTime(detail.createTime)}}</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">备注：</span>
						<span class="value">{{detail.remark}}</span>
					</el-col>
					<el-col :span="12">
						
					</el-col>
				</el-row>
			</div>
			<div style="padding:20px 20px 0;">
				<el-table :data="detail.serviceGoods" style="width: 100%;">
					<el-table-column prop="no" label="序号" width="50">
						<template slot-scope="scope">
							{{scope.$index+1}}
						</template>
					</el-table-column>
					<el-table-column label="名称" prop="goodsName" min-width="150">
						<template slot-scope="props">
							{{props.row.goodsName}}
						</template>
					</el-table-column>
					<el-table-column label="规格" prop="skuValue" min-width="80">
					</el-table-column>
					<el-table-column label="数量" prop="num" min-width="100">
						<template slot-scope="props">
							{{props.row.num}}
						</template>
					</el-table-column>
					<el-table-column label="单位" prop="unit" min-width="60">
					</el-table-column>
					<el-table-column label="出库量" min-width="140">
						<template slot-scope="props">
							<div class="cishu">
								<el-input
								disabled
								v-model="props.row.goodsDosage"
								style="width:100px;">
									<template slot="append" style="padding:0;">{{props.row.outUnit}}</template>
								</el-input>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="单价" prop="originalPrice" min-width="60">
					</el-table-column>
					<el-table-column label="支付状态" min-width="70">
						<template slot-scope="props">
							<span v-if="props.row.isPay" style="color:#18A44C">已支付</span>
							<span v-else>
								<span v-if="props.row.orderNum" style="color:#FDD000">待支付</span>
								<span v-if="!props.row.orderNum" style="color:red;">未支付</span>
							</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div style="text-align: right;padding:30px 20px;">
				<span class="label">总计：</span>
				<span class="value">￥{{detail.totalMoney}}</span>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				detail:{},
			}
		},
		props:{
			curItem:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
				this.getDetail(this.curItem.planId)
			})
		},
		methods: {
			handleClose(){
				this.$emit("submit",{type:'success'})
			},
			// 获取详情
			getDetail(){
				this.$http.get(process.env.VUE_APP_business+'/api/MedicalService/Detail', {id:this.curItem.id}).then(res => {
					if (res.code == 0) {
						res.data.serviceGoodsAll = res.data.serviceGoods
						res.data.serviceGoods = this.filterPlanGoods(res.data.serviceGoods)
						this.detail = res.data;
					}
				})
			},
			// 过滤
			filterPlanGoods(arr){
				let arr1 = []
				for(let i=0;i<arr.length;i++){
					if(arr[i].replaceType!==1){ // 有更换的商品
						arr1.push(arr[i])
					}
				}
				return arr1
			},
		},
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.el-drawer__body{
				overflow: auto;
			}
			.row{
				padding:14px 20px 14px;float: none;font-size: 20px;font-size: 12px;color:#666;border-bottom:1px solid #F2F2F2;
				.label{
					display: inline-block;width:90px;text-align: right;
				}
			}
		}
		
	}
	
</style>
